// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import UserChangeSvg from '@rsuite/icon-font/lib/people/UserChange';
var UserChange = createSvgIcon({
  as: UserChangeSvg,
  ariaLabel: 'user change',
  category: 'people',
  displayName: 'UserChange'
});
export default UserChange;